import './polyfills';
import 'react-hot-loader';
import 'normalize-scss';
import React, { useEffect, useState } from 'react';
import {
  Link, BrowserRouter, Route, Switch, Redirect,
} from 'react-router-dom';
import { hot } from 'react-hot-loader/root';
import './App.scss';

import { setDefaultLocale } from 'react-datepicker';
import nb from 'date-fns/locale/nb';
import { useSelector, useDispatch, connect } from 'react-redux';
import Cookies from 'js-cookie';
import styled from 'styled-components';
import RegisterSlaughter from 'src/routes/RegisterSlaughter/RegisterSlaughter';
import RegisteredSlaughters from 'src/routes/RegisterSlaughter/RegisteredSlaughters';
import { withRouter } from 'react-router';
import { BrandingClothes } from 'src/routes/BrandingClothes/BrandingClothes';
import { company, disableAuth } from 'src/config';
import { Chart } from '@snapper/charts';
import Menu from './Menu';
import Dashboard from './routes/Dashboard/Dashboard';
import Login from './routes/Login/Login';
import { ReturnFormHelp } from './routes/ReturnFormHelp/ReturnFormHelp';

import { routes } from './routes/routes.manifest';
import {
  Column,
} from './components/Layout';
import { Profile } from './routes/Profile/Profile';
import ForgotPassword from './routes/Login/ForgotPassword';
import {
  getLogin,
  getAuth,
  getUserNeedsToConfirmProfileInformation,
} from './store/auth/auth.selectors';
import { ChangePassword } from './routes/Profile/ChangePassword';
import Documents from './routes/Documents/Documents';
import Statistics from './routes/Statistics/Statistics';
import MyCattle from './routes/MyCattle/MyCattle';
import { withToastProvider, useToast } from './components/Toast';
import { BottomMenu } from './BottomMenu';
import { EditProfile } from './routes/Profile/EditProfile';
import Accountings from './routes/Accountings/Accountings';

import { threeHundredAndSixtyFiveDays } from './store/auth/auth.sagas';
import { getPrognosisRegistration, getPrognosisRegistrationConfig } from './store/profile/profile.selectors';
import { profileActions } from './store/profile/profile.actions';
import { getFeaturesEnabled } from './slaughterhouseSpecific';
import { RegisterPrognosisPopup } from './components/RegisterPrognosisPopup';
import LoadingIndicator from './components/LoadingIndicator';

setDefaultLocale(nb);

const ContentColumn = styled(Column)`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex-shrink: 0;
`;

const updateLoggedInCookie = () => {
  if (Cookies.get('logged-in')) {
    Cookies.set('logged-in', true, {
      expires: threeHundredAndSixtyFiveDays, // A year.
    });
  }

  if (disableAuth) {
    Cookies.set('logged-in', true);
  }
  // If cookie is present we won't show login screen.
  // This is set on successful login.
  // If backend respons with unauthorized we will remove it.
};

const chartData = {
  values: [{ group: 0, label: 0, value: 0 }, { group: 1, label: 1, value: 0.75 }, { group: 0, label: 2, value: 0 }, { group: 1, label: 3, value: 3.42 }, { group: 0, label: 4, value: 0 }, { group: 1, label: 5, value: 0.06 }, { group: 0, label: 6, value: 0 }, { group: 1, label: 7, value: 1.53 }, { group: 0, label: 8, value: 0.8 }, { group: 1, label: 9, value: 0.54 }, { group: 0, label: 10, value: 0 }, { group: 1, label: 11, value: 1.5 }, { group: 0, label: 12, value: 0 }, { group: 1, label: 13, value: 0.06 }, { group: 0, label: 14, value: 0 }, { group: 1, label: 15, value: 0.44 }, { group: 0, label: 16, value: 0 }, { group: 1, label: 17, value: 0.24 }, { group: 0, label: 18, value: 0 }, { group: 1, label: 19, value: 0.14 }, { group: 0, label: 20, value: 0 }, { group: 1, label: 21, value: 0.24 }, { group: 0, label: 22, value: 0 }, { group: 1, label: 23, value: 0 }, { group: 0, label: 24, value: 14.4 }, { group: 1, label: 25, value: 5.17 }, { group: 0, label: 26, value: 8.8 }, { group: 1, label: 27, value: 4.97 }, { group: 0, label: 28, value: 0 }, { group: 1, label: 29, value: 0.24 }, { group: 0, label: 30, value: 0 }, { group: 1, label: 31, value: 7.92 }],
  config: {
    groupSelectEnabled: true, barMaxWidth: 100, labelFrequencyOffsetLabels: true, labelFrequencyOffsetPoints: true, groupSelectPosition: 'bottom', decimalSeparator: '.', labelFrequency: 2, barRadiusRatio: 0,
  },
  axes: [{ label: 'Prosent', rounding: 1 }],
  labels: ['Byller Delkass.', 'Byller Delkass.', 'Hjertesekk/brykas', 'Hjertesekk/brysth.bet. ', 'Leddbetkass.', 'Leddbss.', 'Leverbyller Delkass.', 'Leverbyller Delkass.', 'lokal kassasjon', 'lokal kassasjon', 'Lungebetennelse Delkass.', 'Lungebetennelse Delkass.', 'Lungeorm Delkass.', 'Lungeorm Delkass.', 'Små leverikter Delkass.', 'Små leverikter Delkass.', 'Store leverikter', 'Store leverikter', 'Store leverikter Delkass.', 'Store leverikter Delkass.', 'total kassasjon', 'total kassasjon', 'Total kassasjon div årsaker', 'Total kassasjon div årsaker', 'Uren storfehud K1', 'Uren storfehud K1', 'Uren storfehud K2', 'Uren storfehud K2', 'Helkassert', 'Helkassert', 'Delkassert', 'Delkassert'],
  groups: [{
    axis: 0, type: 'bar', name: 'Prosent produsent alle innmeldinger', color: '#64a5e7',
  }, {
    axis: 0, type: 'bar', name: 'Prosent slakteri alle innmeldinger', color: '#2f49a3',
  }],
};

const Test = () => (
  <div>
    <div style={{ background: 'gray', height: '500px' }}>
      Filler
    </div>
    <div
      style={{
        width: '90vw',
        maxWidth: '800px',
        overflow: 'auto',
      }}
    >
      <div style={{
        height: '450px',
        overflow: 'auto',
        position: 'relative',
        width: '1211.2px',
      }}
      >
        <Chart
          scaleToFit
          data={chartData}
        />
      </div>
    </div>
  </div>
);

const App = () => {
  // having this selector present rerenders the page when login-status changes
  const login = useSelector(getLogin); // Rerender after login
  const toast = useToast();
  const auth = useSelector(getAuth); // to detect when user is logged out(dont remove me)
  const userNeedsToConfirmProfileInformation = useSelector(
    getUserNeedsToConfirmProfileInformation,
  );
  const dispatch = useDispatch();

  const prognosisRegistrationConfig = useSelector(getPrognosisRegistrationConfig);
  const prognosisRegistration = useSelector(getPrognosisRegistration);

  const isFetchingPunchoutUrl = useSelector((state) => state.profile.isFetchingPunchoutUrl);

  useEffect(() => {
    dispatch(profileActions.setIsFetchingPunchoutUrl(false));
    // If cookie is set, extend it's lifetime every 30 seconds.
    updateLoggedInCookie();
    const updateCookieInterval = setInterval(updateLoggedInCookie, 30000);
    return () => {
      clearInterval(updateCookieInterval);
    };
  }, []);

  useEffect(() => {
    if (
      !Cookies.get('logged-in')
      && !window.location.href.includes('login')
      && !window.location.href.includes('reset-password')
    ) {
      toast.addMessage('Du ble logget ut');
    }
  }, [login.loggedIn, toast]);

  useEffect(() => {
    if (getFeaturesEnabled().prognosisRegistration && Cookies.get('logged-in') && !prognosisRegistrationConfig.config && !prognosisRegistrationConfig.isFetching && !prognosisRegistrationConfig.error) {
      dispatch(profileActions.fetchPrognosisRegistrationConfig());
    }
  }, [login.loggedIn]);

  return (
    <BrowserRouter basename={process.env.REACT_APP_MOUNT_PATH}>
      {prognosisRegistration.showPopupNow && <RegisterPrognosisPopup />}

      {(Cookies.get('logged-in')
        && userNeedsToConfirmProfileInformation.needToConfirm && (
          <Switch>
            <Route path={routes.profileEdit} component={EditProfile} />
            <Route path={routes.changePw} component={ChangePassword} />
            <Route path={routes.profile} component={Profile} />
            <Redirect from="*" to={routes.profile} />
          </Switch>
      ))
        || (!Cookies.get('logged-in') && (
          <ContentColumn grow shrink>
            <Switch>
              <Route path={routes.login} exact component={Login} />
              <Route path={routes.forgotPw} component={ForgotPassword} />
              <Route
                path={routes.resetPw}
                render={() => <ChangePassword isResetPassword />}
              />
              <Redirect from="*" to={routes.login} />
            </Switch>
          </ContentColumn>
        )) || (
          <>
            <Column grow shrink style={{ height: '100%' }}>
              <Menu />
              {isFetchingPunchoutUrl
                ? (
                  <LoadingIndicator
                    withText
                    customTxt="Omdirigerer ..."
                  />
                )
                : (
                  <Switch>
                    <Route
                      path={routes.changePw}
                      component={ChangePassword}
                    />
                    <Route path={routes.profile} exact component={Profile} />
                    <Route path={routes.profileEdit} component={EditProfile} />
                    <Route path="/test" component={Test} />
                    <Route
                      path={routes.accountingsPosted}
                      component={Accountings}
                    />
                    <Route
                      path={routes.accountingsPosted}
                      component={Accountings}
                    />
                    <Route path={routes.documents} component={Documents} />
                    <Route path={routes.statistics} component={Statistics} />
                    <Route
                      path={routes.registerEnrolment}
                      component={RegisterSlaughter}
                    />
                    <Route
                      path={routes.registeredEnrolments}
                      component={RegisteredSlaughters}
                    />
                    <Route path={routes.myCattle} component={MyCattle} />
                    <Route path={routes.dashboard} component={Dashboard} />
                    <Route
                      path={routes.resetPw}
                      render={() => <ChangePassword isResetPassword />}
                    />
                    <Route
                      path={routes.brandingClothes}
                      component={BrandingClothes}
                    />
                    <Route
                      path={routes.returnFormHelp}
                      component={ReturnFormHelp}
                    />
                    <Redirect from="*" to={routes.dashboard} />
                  </Switch>
                )}
            </Column>
            <BottomMenu />
          </>
      )}
    </BrowserRouter>
  );
};

export default hot(withToastProvider(App));
